import { IField } from "../interfaces/inputs/IField";
import { Endpoints } from "../utils/Endpoints";
import { getForms } from "../utils/Helpers";

const categories = [
  {value: 'english', text: 'English'},
  {value: 'general', text: 'General'},
  {value: 'humanity', text: 'Humanity'},
  {value: 'subsidiary', text: 'subsidiary'},
  {value: 'mathematics', text: 'Mathematics'},
  {value: 'science', text: 'Science'},
]

const terms = [
  {value: 'I', text: 'I'},
  {value: 'II', text: 'II'},
  {value: 'III', text: 'III'}
]

export const PublishmarkFields: IField[] = [
  { name: "term", type: "select", label: "Term", options: terms, position: 2, size: {lg: 4} },
  { name: "year", type: "number", label: "Year", size: {lg: 4}, position: 3 },
  { name: "marktype_id", type: "select", label: "Type", dataType: "marktypes", dataSrc: Endpoints.marktypes, labelField: "label", size: {lg: 4}, position: 5 },
].sort((a: IField, b: IField) => a.position - b.position);